// extracted by mini-css-extract-plugin
export default {"paged":"tGj0A"};